import { render, staticRenderFns } from "./ReAllocationDialog.vue?vue&type=template&id=a778ff06&scoped=true&lang=pug&"
import script from "./ReAllocationDialog.vue?vue&type=script&lang=ts&"
export * from "./ReAllocationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReAllocationDialog.vue?vue&type=style&index=0&id=a778ff06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a778ff06",
  null
  
)

export default component.exports